'use client';

import { useLocalStorage } from '@mantine/hooks';

export const FLAG_OVERRIDES_STORAGE_KEY = 'ff-local-overrides';

export function useFlagOverrides() {
  return useLocalStorage<Record<string, boolean>>({
    key: FLAG_OVERRIDES_STORAGE_KEY,
    defaultValue: {},
  });
}
